import { useBrandStore } from '@jotta/ui/useBrandTheme'
import type { ScrollObservable } from '@jotta/ui/useScroll'
import Debug from 'debug'
import { useLocalObservable } from 'mobx-react-lite'
import { VirtualListStore } from './VirtualListStore'
const debug = Debug('jotta:useVirtualList')

export interface VirtualListOptions<T> {
  idKey: string & keyof T
  items: readonly T[]
  firstItemOffset?: number
  columnWidth?: number
  minColumns?: number
  rowHeight?: number
  cellAspect?: number
  showDebugInfo?: boolean
  onScrollBottom?: () => void

  scrollObservable?: ScrollObservable
}

export function useVirtualList<T>(options: VirtualListOptions<T>) {
  const branding = useBrandStore()
  const store = useLocalObservable(
    () => new VirtualListStore(branding, options),
  )

  return store
}
